module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_01.c6d71942.jpg";